import {
  BankAttributes,
  BusinessPartnerFunctionAttributes,
  BusinessPartnerSubGroupAttributes,
  CompanyAttributes,
  LocationFourAttributes,
  LocationOneAttributes,
  LocationThreeAttributes,
  LocationTwoAttributes,
  PaymentTypeAttributes,
  SubRouteAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { StatusBusinessPartnerEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status-business-partner.enum";
import BusinessPartnerGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import PlantsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants.entity";
import PaymentConditionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule } from "@angular/common";
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { TranslocoModule } from "@ngneat/transloco";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { MapModalComponent } from "app/shared/components/map-modal/map-modal.component";
import {
  MapModalTypeEnum,
  MonitorDocumentTypeEnum,
} from "app/shared/components/map-modal/models/map-modal.enum";
import { MapModalInputData } from "app/shared/components/map-modal/models/map-modal.interface";
import { DateHelper } from "app/utils/date.helper";
import { getCode } from "app/utils/method";
import { countryCodes } from "assets/data/country-data";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { Subscription } from "rxjs";
import { CompanyService } from "../../configuration/company/company.service.service";
import { PlantsService } from "../../configuration/plant/plants.service";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { LocationFourService } from "../../locations/location-four/location-four.service";
import { LocationOneService } from "../../locations/location-one/location-one.service.service";
import { LocationThreeService } from "../../locations/location-three/location-three.service";
import { LocationTwoService } from "../../locations/location-two/location-two.service";
import { PaymentConditionService } from "../../master/payment-condition/payment-condition.service";
import { BankService } from "../../payment-master/bank/bank.service";
import { PaymentTypeService } from "../../payment-master/payment-type/payment-type.service";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { ModalMapComponent } from "../../shared/modal-map/modal-map.component";
import { BusinessPartnerFunctionService } from "../business-partner-function/business-partner-function.service";
import { BusinessPartnerGroupService } from "../business-partner-group/business-partner-group.service";
import { BusinessPartnerSubGroupService } from "../business-partner-sub-group/business-partner-sub-group.service";
import { BusinessPartnerService } from "../business-partner/business-partner.service";
import { BusinessPartnerIntegratosServicesService } from "./business-partner-integrator.service";
import { BusinessPartnerNewsService } from "./business-partner-news.service";
import { BUSINESS_PARTNER_NEWS_TITLE } from "./exports/business-partner-news.constants";
import { BusinessPartnerNewsExport } from "./exports/business-partner-news.export";
import { ICreateBusinessPartnerNew } from "./interfaces/create-business-partner-new.interface";
import { IUpdateBusinessPartnerNew } from "./interfaces/update-business-partner-new.interface";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";

@Component({
  selector: "app-business-partner-news",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatTooltipModule,
    TranslocoModule,
    FilterComponent,
    ConfigurationFiltersComponent,
    StatusFiltersComponent,
    RoutesFiltersComponent,
    DatesFiltersComponent,
    HoverMenuDirective,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    BusinessPartnerNewsExport,
  ],
  templateUrl: "./business-partner-news.component.html",
  styleUrl: "./business-partner-news.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class BusinessPartnerNewsComponent implements OnDestroy, OnInit {
  getCode = getCode;
  statusEnum = StatusBusinessPartnerEnum;
  statusOptions = Object.keys(StatusBusinessPartnerEnum)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      label: this.getStatusLabel(
        StatusBusinessPartnerEnum[key as keyof typeof StatusBusinessPartnerEnum]
      ),
      value:
        StatusBusinessPartnerEnum[
          key as keyof typeof StatusBusinessPartnerEnum
        ],
    }));
  selectedStatus: number[] | null = [];

  displayedColumns: string[] = [
    //"select",
    "det",
    "name",
    "routes",
    "addresses",
    "createdAt",
    "usersAprroved",
    "newBusinessPartnerFlag",
    "action",
  ];

  totalItems = 0;
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof BusinessPartnerAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  dataSource = new MatTableDataSource<BusinessPartnerAttributes>([]);

  selection = new SelectionModel<any>(true, []);

  //detail
  selectedBP: BusinessPartnerAttributes | null = null;
  displayedColumnsDetail: string[] = ["username", "approve", "reason"];
  dataSourceDetail = new MatTableDataSource<any>([]);

  //combos
  locationOneList: LocationOneAttributes[] = [];
  countryCodes = countryCodes;
  listFilterCountryCodes = countryCodes;
  listFilterCountryMobileCodes = countryCodes;
  searchPhone = "";
  searchMobile = "";

  locationTwoList: LocationTwoAttributes[] = [];
  listFilterLocationTwo: LocationTwoAttributes[] = [];
  searchLocationTwo = "";

  locationThreeList: LocationThreeAttributes[] = [];
  listFilterLocationThree: LocationThreeAttributes[] = [];
  listFilterLocationFour: LocationFourAttributes[] = [];
  searchLocationThree = "";

  locationFourList: LocationFourAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  companyFindWithCountList: CompanyAttributes[] = [];
  companyFindWithCountListMap: Map<number, CompanyAttributes> = new Map();

  paymentConditionList: PaymentConditionAttributes[] = [];
  listFilterPaymentCondition: PaymentConditionAttributes[] = [];
  searchPaymentCondition = "";

  businessGroupList: BusinessPartnerGroupAttributes[] = [];
  businessSubGroupList: BusinessPartnerSubGroupAttributes[] = [];
  listFilterBusinessSubGroup: BusinessPartnerSubGroupAttributes[] = [];
  searchSubGroup = "";

  businessFunctionList: BusinessPartnerFunctionAttributes[] = [];
  subRouteList: SubRouteAttributes[] = [];
  listFilterSubRouteList: SubRouteAttributes[] = [];
  searchSubRoute = "";

  plantList: PlantsAttributes[] = [];
  warehouseList: WarehouseAttributes[] = [];
  bankList: BankAttributes[] = [];
  paymentTypeList: PaymentTypeAttributes[] = [];

  currentCreateBusinessPartnerNew: ICreateBusinessPartnerNew =
    this.initializeCreateBp();
  currentUpdateBusinessPartnerNew: IUpdateBusinessPartnerNew; //no se actualiza solo muestro

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild("confirmSynDialog") confirmSynDialog!: TemplateRef<any>;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;
  selectedStatuses: [] = [];
  selectedCustomerType: [] = [];
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;
  private companiesFilterLoaded = false;
  private modalDataLoaded = false;

  //map
  isNew: boolean = true;
  private companyId: number;
  constructor(
    private businessPartnerService: BusinessPartnerService,
    private businessNewsService: BusinessPartnerNewsService,
    private bpIntegratosServicesService: BusinessPartnerIntegratosServicesService,
    private readonly locationOneService: LocationOneService,
    private readonly locationTwoService: LocationTwoService,
    private readonly locationThreeService: LocationThreeService,
    private readonly locationFourService: LocationFourService,
    private readonly companyService: CompanyService,
    private readonly paymentService: PaymentConditionService,
    private readonly subRouteService: SubRouteService,
    private readonly businessGroupService: BusinessPartnerGroupService,
    private readonly businessSubGroupService: BusinessPartnerSubGroupService,
    private readonly businessFunctionService: BusinessPartnerFunctionService,
    private readonly plantService: PlantsService,
    private readonly warehouseService: WarehouseService,
    private readonly bankService: BankService,
    private readonly paymentTypeService: PaymentTypeService,
    private readonly searchService: SearchService,
    public exportService: ExportService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private businessPartnerNewsExport: BusinessPartnerNewsExport,
    private fb: FormBuilder
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      companyId: [],
      routeId: [],
    });
  }

  ngOnInit(): void {
    // this.getAllCompanies();
  }

  ngAfterViewInit(): void {
    this.getAllCompanies();
    this.onHandleSearch();
    this.onFilter();
  }

  onFilter() {
    this.getList();
  }

  clearFilters() {
    this.selectedStatus = [];
    this.form.reset({
      start: new Date(),
      end: new Date(),
      companyId: null,
      businessPartnerTypeId: null,
    });
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.getList();
      }
    );
  }

  getList(): void {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.sortActive,
      sortDirection: this.sortDirection,
    };
    const companyCodes = [environment.companyId];

    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
      companyId: this.form.get("companyId")?.value
        ? this.companyId
        : this.form.get("companyId")?.value,
      routeId: this.form.get("routeId")?.value,
      statusNewBP: this.selectedStatuses.length ? this.selectedStatuses : null,
    };
    this.businessPartnerService
      .findAllWithCount(options, true, filter.statusNewBP, "both", filter)
      .subscribe({
        next: (res: IPaginationResult<BusinessPartnerAttributes>) => {
          this.dataSource.data = res?.data?.[0]?.data ?? [];
          this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener nuevos clientes",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return "--:--:--";
  }

  getStatusLabel(status: number): string {
    const labels: { [key: number]: string } = {
      [StatusBusinessPartnerEnum.APPROVED]: "Registro Aprobado",
      [StatusBusinessPartnerEnum.PENDING]: "Pendiente",
      [StatusBusinessPartnerEnum.IN_PROCESS]: "En proceso de aprobación",
      [StatusBusinessPartnerEnum.REJECTED]: "Rechazado",
    };
    return labels[status] || "Desconocido";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    //return numSelected === numRows;
    return numSelected >= 1;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          if (
            row.newBusinessPartnerFlag == StatusBusinessPartnerEnum.APPROVED
          ) {
            this.selection.select(row);
          }
        });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  toggleDetails(client: BusinessPartnerAttributes): void {
    if (this.selectedBP && this.selectedBP._id === client._id) {
      this.closeDetails();
      return;
    }

    this.selectedBP = client;
    this.dataSourceDetail.data = this.selectedBP?.usersAprroved || [];
  }

  closeDetails(): void {
    this.selectedBP = null;
  }

  openConfirmSynDialog(): void {
    if (this.selection.selected.length == 0) {
      return;
    }

    this.dialog
      .open(this.confirmSynDialog, {
        data: null,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.synchronize());
  }

  synchronize(): void {
    let idBusinessPartner = [];
    this.selection.selected.forEach((s: any) => {
      idBusinessPartner.push(s._id); //TODO QUE MANDAR
    });

    let send = {
      ids: idBusinessPartner,
    };

    //TODO IMPLEMENTAR SERVICIO
    /* this.service.sync(send).subscribe({
      next: () => {
        this.getList()
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    }) */
  }

  openConfirmSynCustomer(element): void {
    this.dialog
      .open(this.confirmSynDialog, {
        data: null,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.sync(element));
  }

  sync(element) {
    let send = {
      ids: [element._id],
    };

    this.bpIntegratosServicesService.sincronize(send).subscribe({
      next: () => {
        this.getList();
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  openModal(element): void {
    if (this.isNew) {
      const data: MapModalInputData = {
        type: MapModalTypeEnum.SIMPLE,
        tripId: null,
        element: element,
        document: MonitorDocumentTypeEnum.NONE,
        groupDocuments: [],
        map: {
          displayMode: "drawer",
          captions: { title: "Ubicación" },
        },
      };

      this.openMap(data);
    } else {
      this.dialog.open(ModalMapComponent, {
        width: "90%",
        data: element.addresses?.[0],
        disableClose: true,
      });
    }
  }

  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: "90%",
      //height: '80%',
      data: data,
    });
  }

  private initializeCreateBp(): ICreateBusinessPartnerNew {
    return {
      name: "",
      commercialName: "",
      address: "",
      phone: "",
      phonePrefix: "",
      mobile: "",
      email: "",
      mobilePrefix: "",
      latitude: "",
      longitude: "",
      legalCode: "",
      visitDays: [],
      locationOneId: "",
      locationTwoId: "",
      locationThreeId: "",
      locationFourId: "",
      businessPartnerGroupId: null,
      businessPartnerSubGroupId: null,
      subRouteId: null,
      useGps: true,
      contact: "",
      businessPartnerFunctionIds: [],
      companyId: "",
      priceListId: null,
      discountListId: null,
      paymentConditionId: "",
      newBusinessPartnerFlag: 1,

      paymentTypeId: "",
      creditLimit: 0,
      bankId: "",
      documentType: "",
      plantId: "",
      warehouseId: "",
    };
  }

  private ensureCompaniesFilterLoaded(): void {
    if (!this.companiesFilterLoaded) {
      this.getAllCompanies();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesFilterLoaded();
  }

  private async ensureModalDataLoaded(): Promise<void> {
    if (!this.modalDataLoaded) {
      await this.initializeModalData();
      this.modalDataLoaded = true;
    }
  }

  private async initializeModalData(): Promise<void> {
    await this.getComboLocationOne();
    this.getComboCompanies();
    this.getComboPaymentCondition();
    await this.getComboBusinessGroup();
    this.getComboBusinessFunction();
    this.getAllRutas();
    this.getComboPlant();
    this.getComboBank();
    this.getComboPaymentType();
  }

  async openCreateModal(): Promise<void> {
    await this.ensureModalDataLoaded();
    this.currentCreateBusinessPartnerNew = this.initializeCreateBp();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      width: "95%",
      maxWidth: "1500px",
      maxHeight: "95vh",
      disableClose: true,
    });

    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  async openEditModal(client: BusinessPartnerAttributes): Promise<void> {
    await this.ensureModalDataLoaded();
    //this.getAllRutas() NO VIENE SUBRUTA

    let location = null;
    if (client.addresses && client.addresses.length > 0) {
      location = client.addresses[0];
    }

    let phone = "";
    let phonePrefix = "";
    let mobile = "";
    let mobilePrefix = "";

    client.phones.forEach((item) => {
      const normalizedType = item.type.type
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase(); // Quita tildes y convierte a mayúsculas
      if (normalizedType.includes("TELEFONO") || normalizedType === "TEL") {
        phone = item.phone;
        phonePrefix = item.prefix;
      } else if (
        normalizedType.includes("MOVIL") ||
        normalizedType === "MO" ||
        normalizedType.includes("MOBILE")
      ) {
        mobile = item.phone;
        mobilePrefix = item.prefix;
      }
    });
    this.currentUpdateBusinessPartnerNew = {
      ...client,
      locationOneId: location?.locationOne?._id || "",
      locationTwoId: location?.locationTwo?._id || "",
      locationThreeId: location?.locationThree?._id || "",
      locationFourId: location?.locationFour?._id || "",
      address: location?.address || "",
      latitude:
        location.geolocationPoint && location.geolocationPoint.length > 0
          ? location.geolocationPoint[0]
          : "",
      longitude:
        location.geolocationPoint && location.geolocationPoint.length > 0
          ? location.geolocationPoint[1]
          : "",
      paymentConditionId: String(client?.paymentCondition?._id) || "",
      companyId:
        client.companies && client.companies.length > 0
          ? String(client.companies[0]._id)
          : "",

      contact:
        client.contacts && client.contacts.length > 0
          ? client.contacts[0].contact?.firstName
          : "",
      mobile: mobile,
      email:
        client.emails && client.emails.length > 0 ? client.emails[0].email : "",
      mobilePrefix: mobilePrefix,
      phone: phone,
      phonePrefix: phonePrefix,
      //subRouteId: NO VIENE,

      businessPartnerGroupId: client?.businessPartnerGroup?._id
        ? String(client?.businessPartnerGroup._id)
        : null,
      businessPartnerSubGroupId: client?.businessPartnerSubGroup?._id
        ? String(client?.businessPartnerSubGroup._id)
        : null,
      newBusinessPartnerFlag: client?.newBusinessPartnerFlag || 1,
      useGps: client?.useGps || true,
      name: client?.name || "",
      commercialName: client?.commercialName || "",
      legalCode: client?.NIT || "",

      paymentTypeId: String(client?.paymentType?._id) || "",
      creditLimit: client?.creditLimit || 0,
      bankId: String(client?.bank?._id) || "",
      documentType: client.documentType || "",
      plantId: client?.distributionChains[0]?.plant?._id
        ? String(client.distributionChains[0].plant._id)
        : "",
      warehouseId: String(client?.distributionChains[0]?.warehouse?._id) || "",
    };

    if (this.currentUpdateBusinessPartnerNew.locationOneId) {
      await this.changeLocationOne(
        this.currentUpdateBusinessPartnerNew.locationOneId
      );
    }

    if (this.currentUpdateBusinessPartnerNew.locationTwoId) {
      await this.changeLocationTwo(
        this.currentUpdateBusinessPartnerNew.locationTwoId
      );
    }
    if (this.currentUpdateBusinessPartnerNew.locationThreeId) {
      await this.changeLocationThree(
        this.currentUpdateBusinessPartnerNew.locationThreeId
      );
    }

    if (this.currentUpdateBusinessPartnerNew.businessPartnerGroupId) {
      this.changeGroup(
        this.currentUpdateBusinessPartnerNew.businessPartnerGroupId
      );
    }

    if (this.currentUpdateBusinessPartnerNew.plantId) {
      this.getComboWarehouse(this.currentUpdateBusinessPartnerNew.plantId);
    }

    this.dialogRefEdit = this.dialog.open(this.editModal, {
      width: "95%",
      maxWidth: "1500px",
      maxHeight: "95vh",
      disableClose: true,
    });
    this.dialogRefEdit
      .afterClosed()
      .subscribe(
        (result) =>
          result &&
          client.newBusinessPartnerFlag != this.statusEnum.APPROVED &&
          this.updateBusinessPartnerNew(String(client._id))
      );
  }

  createBusinessPartnerNew(): void {
    if (!this.currentCreateBusinessPartnerNew) {
      return;
    }

    if (
      this.currentCreateBusinessPartnerNew.useGps &&
      (this.currentCreateBusinessPartnerNew.latitude == null ||
        this.currentCreateBusinessPartnerNew.latitude == "") &&
      (this.currentCreateBusinessPartnerNew.longitude == "" ||
        this.currentCreateBusinessPartnerNew.longitude == null)
    ) {
      this.snackBar.open("Falta ingresar coordenadas", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    if (!this.currentCreateBusinessPartnerNew.mobile) {
      this.currentCreateBusinessPartnerNew.mobilePrefix = null;
    }

    if (!this.currentCreateBusinessPartnerNew.phone) {
      this.currentCreateBusinessPartnerNew.phonePrefix = null;
    }

    const payload = {
      ...this.currentCreateBusinessPartnerNew,
      latitude:
        this.currentCreateBusinessPartnerNew.useGps == false
          ? "0"
          : this.currentCreateBusinessPartnerNew.latitude,
      longitude:
        this.currentCreateBusinessPartnerNew.useGps == false
          ? "0"
          : this.currentCreateBusinessPartnerNew.longitude,
    };

    //CAMBIE SERVICIO PARA CREAR NEW BP
    this.businessNewsService.createnewBP(payload).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        if (this.dialogRefAdd) {
          this.dialogRefAdd.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  updateBusinessPartnerNew(id: string): void {
    if (
      (this.currentCreateBusinessPartnerNew.latitude &&
        !this.currentCreateBusinessPartnerNew.longitude) ||
      (!this.currentCreateBusinessPartnerNew.latitude &&
        this.currentCreateBusinessPartnerNew.longitude)
    ) {
      this.snackBar.open("Falta ingresar coordenadas", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    if (!this.currentUpdateBusinessPartnerNew.mobile) {
      this.currentUpdateBusinessPartnerNew.mobilePrefix = null;
    }

    if (!this.currentUpdateBusinessPartnerNew.phone) {
      this.currentUpdateBusinessPartnerNew.phonePrefix = null;
    }

    let update: any = {
      //BusinessPartnerAttributes
      name: this.currentUpdateBusinessPartnerNew.name,
      commercialName: this.currentUpdateBusinessPartnerNew.commercialName,
      legalCode: this.currentUpdateBusinessPartnerNew.legalCode,
      contact: this.currentUpdateBusinessPartnerNew.contact,
      mobile: this.currentUpdateBusinessPartnerNew.mobile,
      email: this.currentUpdateBusinessPartnerNew.email,
      mobilePrefix: this.currentUpdateBusinessPartnerNew.mobilePrefix, //no se manda
      phone: this.currentUpdateBusinessPartnerNew.phone,
      phonePrefix: this.currentUpdateBusinessPartnerNew.phonePrefix,
      address: this.currentUpdateBusinessPartnerNew.address,
      latitude: String(this.currentUpdateBusinessPartnerNew.latitude),
      longitude: String(this.currentUpdateBusinessPartnerNew.longitude),
      locationOneId: this.currentUpdateBusinessPartnerNew.locationOneId,
      locationTwoId: this.currentUpdateBusinessPartnerNew.locationTwoId,
      locationThreeId: this.currentUpdateBusinessPartnerNew.locationThreeId,
      locationFourId: this.currentUpdateBusinessPartnerNew.locationFourId,
      businessPartnerGroupId:
        this.currentUpdateBusinessPartnerNew.businessPartnerGroupId ?? null,
      businessPartnerSubGroupId:
        this.currentUpdateBusinessPartnerNew.businessPartnerSubGroupId ?? null,
      //TODO nuevos campos cris falta que responda
    };

    this.businessNewsService.updatenewBP(id, update).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
        this.dialogRefEdit.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  openApprove(client: BusinessPartnerAttributes) {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: client,
        requeriment: {
          approve: true,
          approve_generate: false,
          reject: true,
        },
        type: TypeRejectEnum.NUEVO_CLIENTE,
      }, //CLIENTE
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Close") {
      } else {
        if (result) {
          let sendBusinessPartner = {
            id: result.id,
            email: result.email,
            username: result.username,
            rejectedReason: result.rejectedReason ?? null,
            approve: result.approve ? true : false,
          };

          this.getApprovedOrRejected(sendBusinessPartner);
        }
      }
    });
  }

  getApprovedOrRejected(sendBusinessPartner) {
    this.businessPartnerService
      .approveRejectBussinessPartner(sendBusinessPartner)
      .subscribe({
        next: (res: any) => {
          this.snackBar.open("Registro actualizado", "Cerrar", {
            duration: 3000,
          });
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al aprobar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  //filter
  private getComboLocationOne(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.locationOneService.findToComboBox().subscribe({
        next: (res: IRequestResult<LocationOneAttributes[]>) => {
          this.locationOneList = res.data;
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching location one",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  async changeLocationOne(event): Promise<void> {
    this.locationTwoList = [];
    let country = this.locationOneList.find((ele) => ele._id == event);

    await this.getComboLocationTwo(country?.code);
  }

  private getComboLocationTwo(country): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!country) {
        resolve(); // Si no hay país, simplemente resolver la promesa.
        return;
      }

      this.locationTwoService.findToComboBox(country).subscribe({
        next: (res) => {
          this.locationTwoList = res.data;
          this.listFilterLocationTwo = this.locationTwoList.slice();
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching department",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  changueOptionsLocationTwo(event) {
    if (!this.locationTwoList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterLocationTwo = this.locationTwoList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterLocationTwo = this.locationTwoList.filter(
      (item) =>
        item.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  async changeLocationTwo(event): Promise<void> {
    this.locationThreeList = [];
    this.listFilterLocationThree = [];
    let location_two = this.locationTwoList.find((ele) => ele._id == event);
    await this.getComboLocationThree(location_two?.code);
  }

  private getComboLocationThree(location_two): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!location_two) {
        resolve(); // Si no hay país, simplemente resolver la promesa.
        return;
      }
      this.locationThreeService.findToComboBox(location_two).subscribe({
        next: (res) => {
          this.locationThreeList = res.data;
          this.listFilterLocationThree = this.locationThreeList.slice();
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching department",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  changueOptionsLocationThree(event) {
    if (!this.locationThreeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterLocationThree = this.locationThreeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterLocationThree = this.locationThreeList.filter(
      (item) =>
        item.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  async changeLocationThree(event): Promise<void> {
    this.locationFourList = [];
    this.listFilterLocationFour = [];
    let location_three = this.locationThreeList.find((ele) => ele._id == event);

    await this.getComboLocationFour(location_three?.code);
  }

  private getComboLocationFour(location_three): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!location_three) {
        resolve(); // Si no hay país, simplemente resolver la promesa.
        return;
      }

      this.locationFourService.findToComboBox(location_three).subscribe({
        next: (res) => {
          this.locationFourList = res.data;
          this.listFilterLocationFour = this.locationFourList.slice();
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching department",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  changueOptionsLocationFour(event) {
    if (!this.locationFourList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterLocationFour = this.locationFourList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterLocationFour = this.locationFourList.filter(
      (item) =>
        item.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  private getComboPlant(): void {
    this.plantService.findToComboBox().subscribe({
      next: (res) => {
        this.plantList = res.data || [];
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error loading plants:",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changePlant(event): void {
    this.warehouseList = [];
    this.getComboWarehouse(event);
  }

  private getComboWarehouse(plant): void {
    if (!plant) {
      return;
    }

    this.warehouseService.findToComboBox(plant).subscribe({
      next: (res) => {
        this.warehouseList = res.data || [];
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error loading warehouse:",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getComboBank(): void {
    this.bankService.findToComboBox().subscribe({
      next: (res) => {
        this.bankList = res.data || [];
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error loading bank:",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getComboPaymentType(): void {
    this.paymentTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentTypeList = res.data || [];
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error loading payment type",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getComboCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        if (this.companyList.length == 1) {
          //solo para crear
          this.currentCreateBusinessPartnerNew.companyId = String(
            this.companyList[0]._id
          );
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching companies",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getAllCompanies(): void {
    this.companyService
      .findAllWithCount(
        {
          currentPage: 1,
          limitPerPage: Number.MAX_SAFE_INTEGER,
        },
        {
          status: [1, 0],
        }
      )
      .subscribe({
        next: (res) => {
          this.companyFindWithCountList = res?.data?.[0]?.data;
          //TODO: Estos valores deberian obtener de login(aplica para filtro)
          // this.form.patchValue({
          //   companyId: this.companyFindWithCountList[0].id,
          // });
          this.companyId = this.companyFindWithCountList[0].id;
          this.companyFindWithCountListMap = new Map(
            this.companyFindWithCountList.map((company) => [
              company.id,
              company,
            ])
          );
          this.companiesFilterLoaded = true;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching companies",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  private getComboPaymentCondition(): void {
    this.paymentService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentConditionList = res.data;
        this.listFilterPaymentCondition = this.paymentConditionList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching payment condition",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsPaymentCondition(event) {
    if (!this.paymentConditionList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterPaymentCondition = this.paymentConditionList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterPaymentCondition = this.paymentConditionList.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  private getAllRutas(): void {
    this.subRouteService.findToComboBox().subscribe({
      next: (res) => {
        this.subRouteList = res.data;
        this.listFilterSubRouteList = this.subRouteList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching route",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsSubRoute(event) {
    if (!this.subRouteList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSubRouteList = this.subRouteList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSubRouteList = this.subRouteList.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  private getComboBusinessGroup(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.businessGroupService.findToComboBox().subscribe({
        next: (res: IRequestResult<BusinessPartnerGroupAttributes[]>) => {
          this.businessGroupList = res.data;
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching business group",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  changeGroup(event): void {
    this.businessSubGroupList = [];
    let group = this.businessGroupList.find((ele) => ele._id == event);

    this.getComboBusinessSubGroup(group?.id);
  }

  private getComboBusinessSubGroup(group): void {
    if (!group) {
      return;
    }

    this.businessSubGroupService.findToComboBox(group).subscribe({
      next: (res) => {
        this.businessSubGroupList = res.data;
        this.listFilterBusinessSubGroup = this.businessSubGroupList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching business sub group",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsSubgroup(event) {
    if (!this.businessSubGroupList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterBusinessSubGroup = this.businessSubGroupList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterBusinessSubGroup = this.businessSubGroupList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  private getComboBusinessFunction(): void {
    this.businessFunctionService.findToComboBox().subscribe({
      next: (res) => {
        this.businessFunctionList = res.data;
        let functionBp = this.businessFunctionList.filter(
          (ele) => ele.code === "RG" || ele.code === "EM"
        ); //Responsable de pago, Destinatario MCIA
        if (functionBp.length > 0) {
          this.currentCreateBusinessPartnerNew.businessPartnerFunctionIds =
            functionBp.map((f) => String(f._id));
        } else {
          this.snackBar.open("No se encontraron funciones", "Cerrar", {
            duration: 3000,
          });
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching business function",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsPhone(event, type) {
    if (!this.countryCodes) {
      return;
    }
    let search = event;
    if (!search) {
      if (type) {
        this.listFilterCountryCodes = this.countryCodes.slice();
      } else {
        this.listFilterCountryMobileCodes = this.countryCodes.slice();
      }
      return;
    } else {
      search = search.toLowerCase();
    }

    if (type) {
      this.listFilterCountryCodes = this.countryCodes.filter(
        (item) =>
          item.label.toLowerCase().indexOf(search) > -1 ||
          item.value.toLowerCase().indexOf(search) > -1
      );
    } else {
      this.listFilterCountryMobileCodes = this.countryCodes.filter(
        (item) =>
          item.label.toLowerCase().indexOf(search) > -1 ||
          item.value.toLowerCase().indexOf(search) > -1
      );
    }
  }

  //exportar
  onExportButtonPressed() {
    if (!this.businessPartnerNewsExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: BUSINESS_PARTNER_NEWS_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.businessPartnerNewsExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  getRowStringDisplayedApproved(row: BusinessPartnerAttributes): string {
    const companyOnFormFilter = this.companyId;
    const companyApprovedQuantity =
      this.companyFindWithCountListMap.get(companyOnFormFilter)
        ?.numberUsersAprroveBusinessPartner || 0;
    const itemsApproved = row?.usersAprroved?.filter((user) => user.approve);

    return `${itemsApproved?.length || 0} / ${companyApprovedQuantity}`;
  }

  isApproveDisabled(row: BusinessPartnerAttributes): boolean {
    const companyLimit =
      this.companyFindWithCountListMap.get(this.companyId)
        ?.numberUsersAprroveBusinessPartner || 0;

    const approvedCount =
      row?.usersAprroved?.filter((u) => u.approve)?.length || 0;

    // Deshabilitar si ya se alcanzó el límite de aprobadores o si sendERP está activo
    return approvedCount >= companyLimit || row.sendERP === true;
  }

  isSyncDisabled(row: BusinessPartnerAttributes): boolean {
    const companyERPActive =
      this.companyFindWithCountListMap.get(this.companyId)?.ERPActive || false;

    return (
      row.newBusinessPartnerFlag !== StatusBusinessPartnerEnum.APPROVED ||
      !companyERPActive
    );
  }

  openLogModal(element: BusinessPartnerAttributes) {
    let dataToModal = {
      documentIdentifier: element?.NIT,
    };
    this.dialog.open(LogModalComponent, {
      width: "90%",
      data: dataToModal,
      disableClose: true,
    });
  }
}
